import React from 'react';
import { Button } from '@packages/ui/primitives';
import { Inline } from '@packages/ui/layout';
import type { FormEachNode } from '../../../types/layout';
import { resolveAddButtonVariant } from '../../../utils/eachButtonVariants';
import { resolveAddButtonPosition } from '../../../utils/resolveAddButtonPosition';

interface FormEachAddButtonProps {
  node: FormEachNode;
  onClick: () => void;
  className?: string;
}

export const FormEachAddButton = React.memo(function FormEachAddButton({
  node,
  onClick,
  className,
}: FormEachAddButtonProps): React.ReactElement {
  const position = resolveAddButtonPosition(node);
  const variantKey = node.addButton?.variant;
  const isIconOnly = variantKey === 'icon-only';
  const fullWidth = node.addButton?.fullWidth === true || position === 'bottom-full-width';

  return (
    <Inline
      className={className}
      justify={
        position === 'bottom-center' || node.addButton?.align === 'center'
          ? 'center'
          : position === 'top-right' || node.addButton?.align === 'end'
            ? 'end'
            : 'start'
      }>
      <Button
        variant={resolveAddButtonVariant(variantKey)}
        size='sm'
        icon={node.addButton?.icon ?? 'add'}
        label={isIconOnly ? undefined : (node.addButton?.label ?? node.addLabel ?? 'Add Item')}
        onClick={onClick}
        type='button'
        fullWidth={fullWidth}
        semanticId={`${node.name}AddButton`}
      />
    </Inline>
  );
});
